import { api } from "./api";

// 对齐 sign-off canvas page-1「首页 · 角色个性化工作台」
export interface HomeMetric {
  id: string;
  label: string;
  value: string;
  sub?: string | null;
  tone?: "accent" | "danger" | "warn" | "ok" | "lock" | null;
  href?: string | null;
  placeholder?: boolean;
}

export interface HomeTaskItem {
  id: string;
  severity: "danger" | "warn" | "ok" | "info";
  title: string;
  meta: string;
  action?: string | null;
  href?: string | null;
  tag?: string | null;
  count?: number; // 该类待办实际条目数（铃铛徽标 = Σcount）
}

export interface HomeQuickAction {
  icon: string;
  label: string;
  sub?: string | null;
  href?: string | null;
}

export interface HomeBlock {
  kind: "tasks" | "quick";
  title: string;
  placeholder?: boolean;
  note?: string | null;
  tasks: HomeTaskItem[];
  quick: HomeQuickAction[];
}

export interface HomePayload {
  role: string;
  role_label: string;
  role_desc: string;
  metrics: HomeMetric[];
  blocks: HomeBlock[];
}

export const homeApi = {
  fetch: () => api<HomePayload>("/api/v1/home"),
};
